<template>
    <!-- contents -->
    <div id="contents">
        <div class="contents_wrap">
            <h2 class="pg_title">{{ pageTitle }}</h2>
            <skp-breadcrumbs @page-title="val => (pageTitle = val)" />
            <!--search-->
            <div class="srchTop_wrap">
                <ul class="txt_sel">
                    <li class="tit">{{ $t('FIELD.FAQ.CORP') }}</li>
                    <li data-input-type="select" class="sel">
                        <select class="slt_white w20p" v-model="rhqCd" @change="changeRhqCd(1)">
                            <option v-for="code in rhqCdList" :key="code.code" :value="code.code">{{code.codeName}}</option>
                        </select>
                        <select class="slt_white w20p" v-model="corpNo" @change="changeRhqCd(2)">
                            <option v-for="code in corpNoList" :key="code.code" :value="code.code">{{code.codeName}}</option>
                        </select>
                    </li>
                </ul>
            </div>
            <!---->
            <div class="box_wrap">
                <!--TREE-->
                <div class="tree_Management" style="width:280px">
                    <dl class="tree_wrap noLine pl10">
                        <dd>
                            <article class="tree_group">

                                <ul class="tree_list">
                                    <li v-for="menu1 in menuAllTrees" :key="menu1.MENUID">
                                        <a href="javascript:" class="ico_tree" v-if="menu1.subMenu" @click="treeClick($event, menu1.MENUID)"></a>
                                        <span>
                                            <a :ref="'menu-' + menu1.MENUPARENTID + '-' + menu1.MENUID" @click="treeMenuChange($event, menu1)">
                                                <em>{{ menu1.MENUNAME }}</em>
                                            </a>
                                        </span>
                                        <ul class="tree_sub_list">
                                            <li v-for="menu2 in menu1.subMenu" :key="menu2.MENUID">
                                                <a href="javascript:" class="ico_tree" v-if="menu2.subMenu" @click="treeClick($event, menu2.MENUID)">
                                                    <span class="sr_only"></span>
                                                </a>
                                                <span>
                                                    <a :ref="'menu-' + menu1.MENUPARENTID + 
                                                                 '-' + menu2.MENUPARENTID + 
                                                                 '-' + menu2.MENUID"
                                                        @click="treeMenuChange($event, menu2)">
                                                        <em>{{ menu2.MENUNAME }}</em>
                                                    </a>
                                                </span>
                                                <ul class="tree_sub_list">
                                                    <li v-for="menu3 in menu2.subMenu" :key="menu3.MENUID">
                                                        <a href="javascript:" class="ico_tree" v-if="menu3.subMenu" @click="treeClick($event, menu3.MENUID)">
                                                            <span class="sr_only"></span>
                                                        </a>
                                                        <span>
                                                            <a :ref="'menu-' + menu1.MENUPARENTID + 
                                                                         '-' + menu2.MENUPARENTID + 
                                                                         '-' + menu3.MENUPARENTID + 
                                                                         '-' + menu3.MENUID"
                                                                @click="treeMenuChange($event, menu3)">
                                                                <em>{{ menu3.MENUNAME }}</em>
                                                            </a>
                                                        </span>
                                                        <ul class="tree_sub_list">
                                                            <li v-for="menu4 in menu3.subMenu" :key="menu4.MENUID">
                                                                <a href="javascript:" class="ico_tree" 
                                                                   v-if="menu4.subMenu" @click="treeClick($event, menu4.MENUID)">
                                                                    <span class="sr_only"></span
                                                                ></a>
                                                                <span>
                                                                    <a :ref="'menu-' + menu1.MENUPARENTID +
                                                                                 '-' + menu2.MENUPARENTID +
                                                                                 '-' + menu3.MENUPARENTID +
                                                                                 '-' + menu4.MENUPARENTID +
                                                                                 '-' + menu4.MENUID"
                                                                        @click="treeMenuChange($event, menu4)">
                                                                        <em>{{ menu4.MENUNAME }}</em>
                                                                    </a>
                                                                </span>
                                                                <ul class="tree_sub_list">
                                                                    <li v-for="menu5 in menu4.subMenu" :key="menu5.MENUID">
                                                                        <a href="javascript:" class="ico_tree"
                                                                           v-if="menu5.subMenu" @click="treeClick($event, menu5.MENUID)"
                                                                           ><span class="sr_only"></span
                                                                        ></a>
                                                                        <span>
                                                                            <a :ref="'menu-' + menu1.MENUPARENTID +
                                                                                        '-' + menu2.MENUPARENTID +
                                                                                        '-' + menu3.MENUPARENTID +
                                                                                        '-' + menu4.MENUPARENTID +
                                                                                        '-' + menu5.MENUPARENTID +
                                                                                        '-' + menu5.MENUID"
                                                                                @click="treeMenuChange($event, menu5)">
                                                                                <em>{{ menu5.MENUNAME }}</em>
                                                                            </a>
                                                                        </span>
                                                                    </li>
                                                                </ul>
                                                            </li>
                                                        </ul>
                                                    </li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </article>
                        </dd>
                    </dl>
                </div>
                <!--content-->
                <div class="con_Management">
                    <!-- Basic Info head -->
                    <div class="sub_head_Warp">
                        <div class="sub_tit mt25">{{ $t('FIELD.GLOBAL.BASIC.INFO') }}</div>
                        <div class="btn_wrap" v-if="isAdd">
                            <a v-if="this.sysAdmYn == 'Y'" href="javascript:" class="btn_white" title @click="menuAdd()">{{ $t('BUTTON.GLOBAL.ADD') }}</a>
                        </div>
                    </div>
                    <!-- //Basic Info head -->
                    <!-- detail_Basic Info -->
                    <table class="create_table">
                        <colgroup>
                            <col width="14%" />
                            <col width="*" />
                            <col width="15%" />
                            <col width="*" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>{{ $t('FIELD.MENUMNG.SYSTEM.ID') }}</th>
                                <td>
                                    <span class="clearable">
                                        <input type="text" class="text_input w100" v-model="systemId" disabled />
                                    </span>
                                </td>
                                <th>{{ $t('FIELD.MENUMNG.UPPER.MENU.ID') }}</th>
                                <td>
                                    <span class="clearable">
                                        <input type="text" class="text_input w100" v-model="upperMenuId" disabled />
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th>{{ $t('FIELD.MENUMNG.MENU.ID') }}</th>
                                <td>
                                    <span class="clearable">
                                        <input type="text" class="text_input w100" v-model="menuId" disabled />
                                    </span>
                                </td>
                                <th>{{ $t('FIELD.GLOBAL.USE.STATUS') }}<em class="txt_mandatory">*</em></th>
                                <td>
                                    <select class="slt_white w100" v-model="useStatus">
                                        <option value>{{ $t('FIELD.GLOBAL.OPTION.DETAIL.NAME') }}</option>
                                        <option value="N">{{ $t('FIELD.GLOBAL.NO') }}</option>
                                        <option value="Y" seleted>{{ $t('FIELD.GLOBAL.YES') }}</option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <th>{{ $t('FIELD.MENUMNG.MENU.NAME') }}<em class="txt_mandatory">*</em></th>
                                <td colspan="3">
                                    <span class="clearable">
                                        <input type="text" class="text_input w100" v-model="menuName" v-clearable />
                                        <i class="clearable_clear">X</i>
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th>{{ $t('FIELD.MENUMNG.LABEL.TYPE') }}<em class="txt_mandatory">*</em></th>
                                <td>
                                    <label class="radiobox-wrap mr10">
                                        <input type="radio" name="labelType" v-model="labelType" value="TXT" />
                                        <i class="radio-icon"></i>
                                        <em>{{ $t('FIELD.GLOBAL.TEXT')}}</em>
                                    </label>
                                    <label class="radiobox-wrap mr10">
                                        <input type="radio" name="labelType" v-model="labelType" value="IMG" />
                                        <i class="radio-icon"></i>
                                        <em>{{ $t('FIELD.GLOBAL.IMAGE')}}</em>
                                    </label>
                                </td>
                                <th>{{ $t('FIELD.GLOBAL.CREATION') }}<em class="txt_mandatory">*</em></th>
                                <td>
                                    <select class="slt_white w100" v-model="creation">
                                        <option value selected>{{ $t('FIELD.GLOBAL.OPTION.DETAIL.NAME') }}</option>
                                        <option value="N">{{ $t('FIELD.GLOBAL.NO') }}</option>
                                        <option value="Y">{{ $t('FIELD.GLOBAL.YES') }}</option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <th>{{ $t('FIELD.MENUMNG.LEFT.MENU.URL') }}</th>
                                <td colspan="3">
                                    <span class="clearable">
                                        <input type="text" class="text_input w100" v-model="menuUrl" v-clearable />
                                        <i class="clearable_clear">X</i>
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th>{{ $t('FIELD.MENUMNG.LINK.URL') }}</th>
                                <td colspan="3">
                                    <span class="clearable">
                                        <input type="text" class="text_input w100" v-model="linkUrl" v-clearable />
                                        <i class="clearable_clear">X</i>
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th>{{ $t('FIELD.MENUMNG.TARGET.NAME') }}</th>
                                <td>
                                    <select class="slt_white w100" v-model="targetName">
                                        <option value selected>{{ $t('FIELD.GLOBAL.OPTION.DETAIL.NAME') }}</option>
                                        <option v-for="code in targetTypes" :key="code.code" :value="code.code">
                                            {{ code.codeDesc }}
                                        </option>
                                    </select>
                                </td>
                                <th>{{ $t('FIELD.MENUMNG.KNOWLEDGE.YN') }}</th>
                                <td data-input-type="select">
                                    <select class="slt_white w100" v-model="knowledgeYn">
                                        <option value selected>{{ $t('FIELD.GLOBAL.OPTION.DETAIL.NAME') }}</option>
                                        <option value="N">{{ $t('FIELD.GLOBAL.NO') }}</option>
                                        <option value="Y">{{ $t('FIELD.GLOBAL.YES') }}</option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <th>{{ $t('FIELD.MENUMNG.MENU.GROUP') }}</th>
                                <td data-input-type="select" colspan="3">
                                    <select class="slt_white w40" v-model="menuGroup" @change="changeMenuGroup()">
                                        <option value selected>{{ $t('FIELD.GLOBAL.OPTION.DETAIL.NAME') }}</option>
                                        <option v-for="code in menuGroups" :key="code.code" :value="code.code">
                                            {{ code.codeDesc }}
                                        </option>
                                    </select>
                                    <select class="slt_white w40" v-model="menuGroupDtl">
                                        <option value selected>{{ $t('FIELD.GLOBAL.OPTION.DETAIL.NAME') }}</option>
                                        <option v-for="code in menuGroupDtls" :key="code.code" :value="code.code">
                                            {{ code.codeDesc }}
                                        </option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <th>{{ $t('FIELD.MENUMNG.POSTED.ORDER') }}</th>
                                <td>
                                    <span class="clearable">
                                        <input type="text" class="text_input w100" @keyup="onlyNumber($event)" v-model="postedOrder" v-clearable />
                                        <i class="clearable_clear">X</i>
                                    </span>
                                </td>
                                <th>PC Only</th>
                                <td>
                                    <select class="slt_white w100" v-model="pcOnlyYn">
                                        <option value="N" seleted>{{ $t('FIELD.GLOBAL.NO') }}</option>
                                        <option value="Y">{{ $t('FIELD.GLOBAL.YES') }}</option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <th>Content View</th>
                                <td>
                                    <select class="slt_white w100" v-model="contentView">
                                        <option value="N" seleted>{{ $t('FIELD.GLOBAL.NO') }}</option>
                                        <option value="Y">{{ $t('FIELD.GLOBAL.YES') }}</option>
                                    </select>
                                </td>
                                <th>Content Order</th>
                                <td>
                                    <span class="clearable">
                                        <input type="text" class="text_input w100" @keyup="onlyNumber($event)" v-model="contentOrder" 
                                               :disabled="contentView == 'N'" v-clearable />
                                        <i class="clearable_clear">X</i>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="btn_wrap_full topLine"></div>
                    <!-- //detail_Basic Info -->
                    <!-- Setting Label head -->
                    <div class="sub_head_Warp">
                        <div class="sub_tit mt25">{{ $t('SUBTITLE.MENUMNG.SETTING.LABEL') }}</div>
                        <div class="btn_wrap" v-if="locales.length > 0">
                            <a v-if="this.sysAdmYn == 'Y'" href="javascript:" class="btn_white" title @click="localeCopy()">{{
                                $t('BUTTON.GLOBAL.COPY')
                            }}</a>
                        </div>
                    </div>
                    <!-- //Setting Label head -->
                    <!-- Setting Label List -->
                    <table class="scroll_table">
                        <colgroup>
                            <col width="25%" />
                            <col width="30%" />
                            <col width="*" />
                        </colgroup>
                        <thead>
                            <th>{{ $t('FIELD.GLOBAL.LANGUAGE') }}</th>
                            <th>{{ $t('FIELD.MENUMNG.NOMAL.STATUS') }}</th>
                            <th>{{ $t('FIELD.MENUMNG.MOUSE.OVER') }}</th>
                        </thead>
                        <tbody>
                            <tr v-for="locale in locales" :key="locale.locale" @change="changeLocale(locale)">
                                <td class="tC w13_5">{{ locale.LOCALEDESC }}</td>
                                <td class="tC">
                                    <span class="clearable">
                                        <input type="text" class="text_input w100" v-model="locale.LABELINFO" />
                                        <i class="clearable_clear">X</i>
                                    </span>
                                </td>
                                <td class="tC">
                                    <span class="clearable">
                                        <input type="text" class="text_input w100" v-model="locale.LABELOVERINFO" />
                                        <i class="clearable_clear">X</i>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- //Setting Label List -->

                    <!-- Authorization tit -->
                    <div class="sub_tit mt25 w100">{{ $t('SUBTITLE.GLOBAL.AUTHORIZATION') }}</div>
                    <!-- //Authorization tit -->
                    <!-- //Authorization tab -->
                    <div class="tab_wrap">
                        <ul class="tab_menu_02 tab_menus">
                            <li :class="{on: tabMode === 'R'}">
                                <a href="javascript:" @click="tabMode = 'R'">{{$t('FIELD.USER.ROLE')}}</a>
                            </li>
                            <li :class="{on: tabMode === 'U'}">
                                <a href="javascript:" @click="tabMode = 'U'">{{$t('FIELD.GLOBAL.USER')}}</a>
                            </li>
                            <div class="btn_wrap fR" v-if="this.sysAdmYn == 'Y'">
                                <a href="JavaScript:" class="btn_sm_white" @click="tabAdd()">{{$t('BUTTON.GLOBAL.ADD')}}</a>
                                <a href="JavaScript:" class="btn_sm_white" @click="tabDel()">{{$t('BUTTON.GLOBAL.DELETE')}}</a>
                            </div>
                        </ul>
                        <div class="tab_contents_list">
                            <!-- Role Tab 영역-->
                            <div class="tab_cont" v-if="tabMode == 'R'">
                                <table class="scroll_table">
                                    <thead>
                                        <tr>
                                            <th class="w10" width="7%">
                                                <label class="checkbox-wrap">
                                                    <input type="checkbox" name value />
                                                    <i class="check-icon"></i>
                                                </label>
                                            </th>
                                            <th width="30%">{{ $t('FIELD.GLOBAL.ID') }}</th>
                                            <th width="40%">{{ $t('FIELD.GLOBAL.ROLE.NAME') }}</th>
                                            <th width="*">{{ $t('FIELD.GLOBAL.CREATION') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="auth in authRoles" :key="auth.AUTHCORPID">
                                            <td class="tC w10" width="7%">
                                                <label class="checkbox-wrap">
                                                    <input type="checkbox" v-model="auth.selected" />
                                                    <i class="check-icon"></i>
                                                </label>
                                            </td>
                                            <td class="tC" width="30%">{{auth.AUTHID}}</td>
                                            <td class="tC" width="40%">{{auth.AUTHNM}}</td>
                                            <td class="tC" width="*">{{auth.CREATIONYN}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <!-- User Tab 영역-->
                            <div class="tab_cont" v-if="tabMode == 'U'">
                                <table class="scroll_table">
                                    <thead>
                                        <tr>
                                            <th class="w10" width="7%">
                                                <label class="checkbox-wrap">
                                                    <input type="checkbox" name value />
                                                    <i class="check-icon"></i>
                                                </label>
                                            </th>
                                            <th width="30%">{{ $t('FIELD.GLOBAL.ID') }}</th>
                                            <th width="40%">{{ $t('FIELD.USER.NAME') }}</th>
                                            <th width="*">{{ $t('FIELD.GLOBAL.CREATION') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="user in authUsers" :key="user.LOGINNO">
                                            <td class="tC w10" width="7%">
                                                <label class="checkbox-wrap">
                                                    <input type="checkbox" v-model="user.selected" />
                                                    <i class="check-icon"></i>
                                                </label>
                                            </td>
                                            <td class="tC" width="30%">{{user.LOGINID}}</td>
                                            <td class="tC" width="40%">{{user.LOGINNM}}</td>
                                            <td class="tC" width="*">{{user.CREATIONYN}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <!-- //Authorization tab -->
                </div>
            </div>
            <!---->
            <!-- page btn -->
            <div class="btn_wrap_full topLine">
                <div class="btn_right" v-if="isSave">
                    <a v-if="this.sysAdmYn == 'Y'" href="javascript:" class="btn_blue" title @click="menuSave()">{{ $t('BUTTON.GLOBAL.SAVE') }}</a>
                    <!-- Create 일때 save버튼 생성-->
                </div>
            </div>
        </div>
    </div>
    <!-- contents -->
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import qs from 'query-string';
import _ from 'lodash';
import $ from 'jquery';
import { SDLUtil, MenuUtil } from '@/utils';
import { EventBus } from '@/utils/EventBus';
import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';
import RoleAddPopup from './RoleAddPopup';
import UserAddPopup from '~va/system/userRole/UserAddPopup';
import { mapGetters } from 'vuex';
import api from '@/service';
import constants from '@/constants';

// ToastGrid UseYn Type renderer
export default {
    name: 'MenuAdminList',
    props: {
        params: {},
    },
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
    },
    data() {
        return {
            isLoading: true,
            loadingStatus: 'loading', // 'done', 'error'
            pageTitle: '',
            rhqCdList: [],
            corpNoList: [],
            isAdd: false,
            isSave: false,
            rhqCd: '',
            corpNo: '',
            pcOnlyYn: '',
            systemId: '',
            menuId: '',
            upperMenuId: '',
            useStatus: '',
            menuName: '',
            menuLevel: 0,
            labelType: '',
            creation: '',
            menuUrl: '',
            linkUrl: '',
            targetName: '',
            knowledgeYn: '',
            menuGroup: '',
            menuGroupDtl: '',
            postedOrder: '',
            contentView: 'N',
            contentOrder: 0,
            targetTypes: [],
            menuGroups: [],
            menuGroupDtls: [],
            menuAllTrees: [],
            locales: [], // Settin Label
            updateLocales: [],
            tabMode: 'R', // 탭 모드: R=Role, U=User
            authRoles: [], // Role 탭
            authUsers: [], // User 탭
            options: {
                scrollX: false,
                scrollY: false,
            },
            sysAdmYn:'',
        };
    },
    computed: {
        ...mapGetters({
            loginNo: 'getLoginNo',
        }),
        getLoginNo() {
            return this.loginNo || '';
        },
    },
    methods: {
        async getCodeComboList(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.getLoginNo);
            return codeResp;
        },
        loadSubsiCodes(mode, pCode) {
            if (mode == 1) {
                // RhqCd
                this.getCodeComboList(this.getLoginNo, 'RHQ_AUTH_ACCESS_CD').then(data => {
                    this.rhqCdList = data;
                    this.rhqCd = data[0].code;
                    this.loadSubsiCodes(2, this.rhqCd);
                });
            } else if (mode == 2) {
                // CorpNo
                this.getCodeComboList(pCode, 'SUB_AUTH_ACCESS_CD').then(data => {
                    this.corpNoList = data;
                    this.corpNo = data[0].code;
                    this.loadMenuList();
                });
            }
        },
        loadCommonCodes(pCode, defCd) {
            let param = { pCode: pCode };
            return axios
                .post(`${SDLUtil.API_URL}/basis/admin/menu/menuMngComCodes.skp`, qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    params: { searchInfo: 'set' },
                })
                .then(resp => {
                    if (resp.data.menuGroups) {
                        this.targetTypes = resp.data.targetTypes;
                        this.menuGroups = resp.data.menuGroups;
                    } else { // 서브코드
                        this.menuGroupDtls = resp.data.menuGroupDtls;
                        if (defCd) this.menuGroupDtl = defCd;
                        else       this.menuGroupDtl = '';
                    }
                })
                .catch(err => {
                    console.log('Error occured : ', err);
                });
        },
        loadMenuList() {
            const param = { corpNo: this.corpNo };
            return axios
                .post(`${SDLUtil.API_URL}/basis/admin/system/menu/menuTreeList.skp`, qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    params: { searchInfo: 'set' },
                })
                .then(resp => {
                    let menuTree1 = [];
                    let menuTree2 = [];
                    let menuTree3 = [];
                    let menuTree4 = [];
                    let menuTree5 = [];

                    for (const menu of resp.data.rowData) {
                        if (1 === menu.MENULEVEL) {
                            menuTree1.push(menu);
                        } else if (2 === menu.MENULEVEL) {
                            menuTree2.push(menu);
                        } else if (3 === menu.MENULEVEL) {
                            menuTree3.push(menu);
                        } else if (4 === menu.MENULEVEL) {
                            menuTree4.push(menu);
                        } else if (5 === menu.MENULEVEL) {
                            menuTree5.push(menu);
                        }
                    }

                    menuTree4 = this.menuTreeMerge(menuTree4, menuTree5);
                    menuTree3 = this.menuTreeMerge(menuTree3, menuTree4);
                    menuTree2 = this.menuTreeMerge(menuTree2, menuTree3);
                    menuTree1 = this.menuTreeMerge(menuTree1, menuTree2);

                    this.menuAllTrees = menuTree1;
                })
                .catch(err => {
                    Vue.$log.error(err);
                });
        },
        menuTreeMerge(parent, cildren) {
            for (const menus of parent) {
                const addMenu = new Array();
                for (const subMenu of cildren) {
                    if (subMenu.MENUPARENTID === menus.MENUID) {
                        addMenu.push(subMenu);
                    }
                }
                if (0 < addMenu.length) {
                    menus.subMenu = addMenu;
                }
            }
            return parent;
        },
        treeClick(e) {
            if (
                $(e.target)
                    .closest('li')
                    .hasClass('active') == true
            ) {
                $(e.target)
                    .closest('li')
                    .removeClass('active');
            } else {
                $(e.target)
                    .closest('li')
                    .addClass('active');
            }
        },
        loadDetailInfo(obj) {
            SDLUtil.showLoadingBar(true);
            const param = { systemId: obj.SYSTEMID,  menuId: obj.MENUID, corpNo: this.corpNo };
            this.systemId    = obj.SYSTEMID;
            this.menuId      = obj.MENUID;
            this.upperMenuId = obj.MENUPARENTID;
            this.menuName    = obj.MENUNAME;
            this.menuLevel   = obj.MENULEVEL;
            return axios
                .post(`${SDLUtil.API_URL}/basis/admin/system/menu/getMenuDetailInfo.skp`, qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    params: { searchInfo: 'set' }
                })
                .then(resp => {
                    console.log('resp.data ==> ', resp.data);
                    if (resp.data.menuInfo) {
                        let menuInfo      = resp.data.menuInfo;
                        this.useStatus    = menuInfo.useYn;
                        this.labelType    = menuInfo.labelType;
                        this.creation     = menuInfo.creationYn;
                        this.pcOnlyYn     = menuInfo.pcOnlyYn;
                        this.contentView  = menuInfo.contentView;
                        this.contentOrder = menuInfo.contentOrder;
                        this.menuUrl      = menuInfo.leftMenuUrl;
                        this.linkUrl      = menuInfo.connUrl;
                        this.targetName   = menuInfo.outputNm;
                        if (this.targetName == undefined) this.targetName = '';
                        this.knowledgeYn  = menuInfo.knowledgeYn;
                        this.menuGroup    = (menuInfo.menuGroup ? menuInfo.menuGroup : '');
                        this.menuGroupDtl = (menuInfo.menuGroupDetail ? menuInfo.menuGroupDetail : '');
                        this.postedOrder  = menuInfo.sort;
                        if (this.menuGroup) {
                            this.loadCommonCodes(this.menuGroup, this.menuGroupDtl);
                        }

                        this.locales   = resp.data.labelInfo.rowData;
                        this.list2Str(this.locales);
                        this.authRoles = resp.data.authInfo.rowData;
                        this.authUsers = resp.data.userInfo.rowData;
                        this.isSave = true;

                        SDLUtil.showLoadingBar(false);
                    } else { // reset
                        this.formReset(false);
                        SDLUtil.showLoadingBar(false);
                    }
                    this.isAdd = true;
                })
                .catch(err => {
                        SDLUtil.showLoadingBar(false);
                    Vue.$log.error(err);
                });
        },
        formReset(isNew) {
            if (isNew) {
                this.upperMenuId = this.menuId;
                this.menuId = '';
                this.menuName = '';
            }
            this.useStatus = 'Y';
            this.labelType = 'TXT';
            this.creation = '';
            this.menuUrl = '';
            this.linkUrl = '';
            this.targetName = '';
            this.knowledgeYn = '';
            this.menuGroup1 = '';
            this.menuGroup2 = '';
            this.postedOrder = '';

            this.locales       = [];
            this.updateLocales = [];
            this.authRoles     = [];
            this.authUsers     = [];
        },
        treeMenuChange(e, obj) {
            $('.tree_list').find('em').removeClass('txt_bold'); // 다른 것들 모두 해제
            $(e.target).closest('em').addClass('txt_bold'); // 클릭 한 것만 굵게..
            this.loadDetailInfo(obj);
        },
        changeRhqCd(mode) {
            if (mode == 1) { // change RhqCd
                this.loadSubsiCodes(2, this.rhqCd);
            } else { // change CorpNo
                this.loadMenuList();
            }
        },
        changeMenuGroup() {
            if (!this.menuGroup || this.menuGroup == '') {
                this.menuGroupDtls = [];
                this.menuGroupDtl = '';
            } else {
                this.loadCommonCodes(this.menuGroup);
            }
        },
        // 그리드 row 클릭 시...
        menuAdd() {
            this.formReset(true);
        },
        list2Str(orgs) {
            this.updateLocales = [];
            orgs.forEach(elm => {
                let str1 = elm.LOCALE;
                let str2 = elm.LABELINFO;
                let str3 = elm.LABELOVERINFO;
                if (str2 == undefined || str2 == 'undefined') str2 = '';
                if (str3 == undefined || str3 == 'undefined') str3 = '';
                this.updateLocales.push(str1 + '$' + str2 + '$' + str3);
            });
        },
        // 로케일 복사
        localeCopy() {
            let first1 = this.locales[0].LABELINFO;
            let first2 = this.locales[0].LABELOVERINFO;
            let nList = [];
            this.locales.forEach(elm => {
                elm.LABELINFO = first1;
                elm.LABELOVERINFO = first2;
                nList.push(elm);
            });
            this.locales = nList;
            this.list2Str(nList);
        },
         changeLocale(loc) {
            let str1 = loc.LOCALE;
            let str2 = loc.LABELINFO;
            let str3 = loc.LABELOVERINFO;
            let newList = [];
            this.updateLocales.forEach(elm => {
                let spl = elm.split('$');
                let code = spl[0];
                if (code == str1) {
                    elm = str1 + '$' + str2 + '$' + str3;
                }
                newList.push(elm);
            });
            this.updateLocales = newList;
         },
        // aftMode: 1=goList, 2=refresh
        saveExec(url, param, aftMode) {
            SDLUtil.showLoadingBar(true);
            return axios
                .post(url, qs.stringify(param), {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                })
                .then(resp => {
                    SDLUtil.showLoadingBar(false);
                    console.log('resp.data.result ==> ', resp.data.result);
                    if (resp.data.result == 1) {
                        Vue.toasted.show(
                            SDLUtil.getMsgProp('MESSAGE.SUCCESS.SAVED'), {
                                theme: "toasted-primary",
                                position: "top-center",
                                duration : 3000
                            }
                        );
                        if (aftMode == 0) {
                            this.loadMenuList();
                        }
                    } else if (resp.data.result == 2) {
                        SDLUtil.alert('TITLE.PERSONALIZE.AUTH.REQUEST');
                    } else if (resp.data.result == 3) {
                        Vue.toasted.show(
                            SDLUtil.getMsgProp('MESSAGE.MENU.DUPLICATE.GROUP'), {
                                theme: "toasted-primary",
                                position: "top-center",
                                duration : 4000
                            }
                        );
                    } else {
                        SDLUtil.alert('Error occured ' + resp.data.result);
                    }
                })
                .catch(err => {
                    console.log('Error occured : ', err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        //
        preSaveParams() {
            let saveAuthRoles = [];
            this.authRoles.forEach(elm => {
                const auth = elm.AUTHCORPID + '^' + elm.CREATIONYN;
                saveAuthRoles.push(auth);
            });

            let saveUsers = [];
            this.authUsers.forEach(elm => {
                const user = elm.LOGINNO + '^' + elm.CREATIONYN;
                saveUsers.push(user);
            });

            let params = {
                systemId: this.systemId,
                menuId: this.menuId,
                menuPid: this.upperMenuId,
                menuId: this.menuId,
                menuNm: this.menuName,
                menuLevel: (this.menuLevel ? this.menuLevel + 1 : 2),
                menuType: 'LEFT',
                useYn: this.useStatus,
                labelType: this.labelType,
                creationYn: this.creation,
                leftMenuUrl: this.menuUrl,
                connUrl: this.linkUrl,
                outputNm: this.targetName,
                knowledgeYn: this.knowledgeYn,
                popupYn: 'N', // 사용안함
                menuGroup: this.menuGroup,
                menuGroupDetail: this.menuGroupDtl,
                sort: this.postedOrder,
                locales  : this.updateLocales,
                authRoles: saveAuthRoles,
                authUsers: saveUsers,
                corpNo: this.corpNo,
                pcOnlyYn: this.pcOnlyYn,
                contentView: this.contentView,
                contentOrder: this.contentOrder
            };
            return params;
        },
        validateion() {
            let bRes = true;
            let valids = [this.menuName, this.useStatus, this.labelType, this.creation, this.targetName];
            let titles = ['Menu Name', 'Use Status', 'Label Type', 'Creation', 'Target Name'];
            $.each(valids, function(idx, elm) {
                if (!elm) {
                    bRes = false;
                    SDLUtil.alert('Empty value of [' + titles[idx] + ']');
                    return;
                }
            });
            return bRes;
        },
        // 메인 저장
        menuSave() {
            if (!this.validateion()) return;
            const param = this.preSaveParams();
            const url = `${SDLUtil.API_URL}/basis/admin/system/menu/saveMenuDetail.skp`;
            SDLUtil.confirm({
                msg: 'MESSAGE.HME.SUBMIT.CONFIRM',
                title: 'BUTTON.GLOBAL.SAVE',
                onOkEvt: () => {
                    this.saveExec(url, param, 0);
                }
            });
        },
        userAddToList(authUsers, creationYn) { // UserList에 추가
            authUsers.forEach(elm => {
                const spl = elm.split('^');
                const obj = {
                    selected: false,
                    LOGINNO: spl[0],
                    LOGINID: spl[1],
                    LOGINNM: spl[2],
                    CREATIONYN: creationYn
                };
                if (!SDLUtil.existArrays(this.authUsers, 'LOGINNO', obj.LOGINNO)) {
                    this.authUsers.push(obj);
                }
            });
        },
        tabAdd() {
            SDLUtil.showLoadingBar(true);
            if (this.tabMode == 'R') { // Role Add Popup
                SDLUtil.show(
                    RoleAddPopup,
                    {
                        title: 'Select Role',
                        pMenuMode: true,
                        pCorpNo: this.corpNo,
                        rtnRoleFunc: (arg1) => {
                            if (!SDLUtil.existArrays(this.authRoles, 'AUTHCORPID', arg1.AUTHCORPID)) {
                                this.authRoles.push(arg1);
                            }
                        }
                    }, // component params
                    {
                        height: 'auto',
                    }, // dialog params
                );
            } else if (this.tabMode == 'U') { // User Search Popup
                SDLUtil.show(
                    UserAddPopup,
                    {
                        title: 'Search User',
                        pRhqCdList: this.rhqCdList,
                        pCorpNoList: this.corpNoList,
                        pMenuMode: true,
                        rtnUserFunc: (arg1, arg2) => {
                            this.userAddToList(arg1, arg2);
                        }
                    }, // component params
                    {
                        height: 'auto',
                    }, // dialog params
                );
            }
            SDLUtil.showLoadingBar(false);
        },
        tabDel() {
            let bCheck = false;
            let remainItems = [];
            if (this.tabMode == 'R') { // Role Add Popup
                this.authRoles.forEach(elm => {
                    let chk = elm.selected;
                    if (!chk) remainItems.push(elm);
                    else bCheck = true;
                });
                this.authRoles = remainItems;
            } else if (this.tabMode == 'U') { // User Search Popup
                this.authUsers.forEach(elm => {
                    let chk = elm.selected;
                    if (!chk) remainItems.push(elm);
                    else bCheck = true;
                });
                this.authUsers = remainItems;
            }
            if (!bCheck) {
                SDLUtil.alert('MESSAGE.GROBAL.NOSELECT');
                return;
            }
        },
        clickSearch() {
            this.onSearch(1);
        }, // clickSearch
        onlyNumber(e) { SDLUtil.onlyNumber(e); }
    }, // methods
    created() {},
    mounted() {
    	this.sysAdmYn = SDLUtil.isRoleExist(`${constants.SYSTEM_ADMIN}`) ? 'Y' : 'N' ;
        this.loadSubsiCodes(1, ''); // RhqCd만 load..
        this.loadCommonCodes();
       
    },
    beforeDestroy() {
        // [필수] EventBus 를 통해 등록된 이벤트는 컴포넌트 종료시 반드시 종료한다.
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/system/menu/MenuAdminList.vue